import { InjectionToken, type Signal } from '@angular/core';

export interface BulkJobProgressEvent {
  progress: number;
  message?: string;
}

export interface BulkJobCompletedEvent<T = unknown> {
  result: T;
}

export interface BulkJobsGateway {
  subscribe(queueName: string, jobId: string): void;
  unsubscribe(queueName: string, jobId: string): void;
  getJobProgressEvent(queueName: string, jobId: string): Signal<BulkJobProgressEvent | undefined>;
  getJobCompleted<T>(queueName: string, jobId: string): Signal<BulkJobCompletedEvent<T> | undefined>;
  getJobError?(queueName: string, jobId: string): Signal<string | undefined>;
}

export const BULK_JOBS_GATEWAY = new InjectionToken<BulkJobsGateway>('BulkJobsGateway');
